<div [style]="{ width: '540px' }" role="dialog">
  <gstar-header-modal id="modal-approval-question" [hasCloseButton]="false">
    <span>
      @if (counter() === isSingle) {
        {{ 'editTaxResultList.confirmationSingleApprovalTitle' | translate }}
      } @else {
        {{ 'editTaxResultList.confirmationPluralApprovalTitle' | translate }}
      }
    </span>
  </gstar-header-modal>
  <gstar-body-modal>
    <p>
      {{ 'editTaxResultList.confirmationApprovalBody' | translate }}
      <span>
        @if (counter() === isSingle) {
          {{
            security().entity.entityType.name +
              ' - ' +
              security().securityType.name +
              ' - ' +
              security().investmentJurisdiction.country.name
          }}
        } @else {
          {{
            'taxResult.counterSecurities' | translate: { counter: counter() }
          }}
        }
      </span>
      {{ 'shared.questionSymbol' | translate }}
    </p>
  </gstar-body-modal>
  <gstar-footer-modal id="modal-approval-question" />
</div>
